import React from 'react';
import PropTypes from 'prop-types';

function RenderTableHeader(props) {
  const {
    tableContent, sortData, filter,
  } = props;

  const isActiveSort = (key, sortedBy) => {
    const { sort, sortBy } = filter;
    if (sort === key && (sortBy === sortedBy)) {
      return 'active';
    }
    return '';
  };

  const renderTableHeader = () => {
    const htmlContent = [];
    Object.keys(tableContent).forEach((key) => {
      htmlContent.push(
        <div className={`d-flex-table-col ${tableContent[key].class}`} key={key}>
          <span className="sort-col">
            {tableContent[key].name}
            {tableContent[key].sort ? (
              <>
                <em
                  className={isActiveSort(key, 1)}
                  onClick={() => { sortData(`${key}`, 1); }}
                />
                <em
                  className={isActiveSort(key, -1)}
                  onClick={() => { sortData(`${key}`, -1); }}
                />
              </>
            )
              : ''}
          </span>
        </div>,
      );
    });
    return htmlContent;
  };

  return (
    <>
      {renderTableHeader()}
    </>
  );
}

RenderTableHeader.propTypes = {
  tableContent: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  sortData: PropTypes.func.isRequired,
};

export default RenderTableHeader;
